import React from "react";
import Icon from "../Icon";
import { DECEDENT_RELATIONSHIPS } from "assets/scripts/constants/Constants";
import uid from "assets/scripts/utils/uid";
export default class Relationship extends React.Component {
    constructor() {
        super(...arguments);
        this._uid = uid();
        this._getTriggerId = () => `editRelationship-${this.props.account.id}-${this._uid}`;
        this._handleButtonClick = (event) => {
            event.stopPropagation();
            this.props.openModal({
                modalId: "editRelationship",
                triggerId: this._getTriggerId()
            });
            this.props.setAccountToEdit(this.props.account.id);
        };
    }
    render() {
        const { props } = this;
        const { relationship } = props.account;
        const triggerId = this._getTriggerId();
        return (<div className={props.className}>
				<div>
					<p>{DECEDENT_RELATIONSHIPS[relationship] || relationship}</p>
				</div>
				<div>
					<button type="button" className="btn btn_icon mix-btn_reverse js-modal-btnTrigger btn-action btn-edit-relationship" data-modaltriggerid={triggerId} aria-label="Edit Relationship" onClick={this._handleButtonClick}>
						<span className="u-isVisuallyHidden">Edit Relationship</span>
						<Icon icon="edit"/>
					</button>
				</div>
			</div>);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/Relationship/Relationship.tsx